
// 防水墙验证CODE
export const CAPTCHA_CODE = '188957083';
